module.exports = __webpack_public_path__ + "static/media/Fusion 360 + Consumer Products workflows.a9b2061e.png";